import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const investorPackageApi = createApi({
  reducerPath: "investorPackageApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["InvestorPackage"],
  endpoints: (builder) => ({
    getAllPackages: builder.query({
      query: (params) => ({ url: "/investor-packages", params }),
      transformResponse: (response) => response.data || { packages: [], stats: {} },
      providesTags: ["InvestorPackage"],
    }),
    getPackageById: builder.query({
      query: (id) => `/investor-packages/${id}`,
      transformResponse: (response) => response.data?.package || null,
      providesTags: (r, e, id) => [{ type: "InvestorPackage", id }],
    }),
    createPackage: builder.mutation({
      query: (data) => ({ url: "/investor-packages", method: "POST", body: data }),
      invalidatesTags: ["InvestorPackage"],
    }),
    updatePackage: builder.mutation({
      query: ({ id, ...data }) => ({ url: `/investor-packages/${id}`, method: "PUT", body: data }),
      invalidatesTags: ["InvestorPackage"],
    }),
    deletePackage: builder.mutation({
      query: (id) => ({ url: `/investor-packages/${id}`, method: "DELETE" }),
      invalidatesTags: ["InvestorPackage"],
    }),
    shareWithBuyer: builder.mutation({
      query: ({ id, ...data }) => ({ url: `/investor-packages/${id}/share`, method: "POST", body: data }),
      invalidatesTags: ["InvestorPackage"],
    }),
    updateBuyerResponse: builder.mutation({
      query: ({ id, ...data }) => ({ url: `/investor-packages/${id}/buyer-response`, method: "PATCH", body: data }),
      invalidatesTags: ["InvestorPackage"],
    }),
  }),
});

export const {
  useGetAllPackagesQuery,
  useGetPackageByIdQuery,
  useCreatePackageMutation,
  useUpdatePackageMutation,
  useDeletePackageMutation,
  useShareWithBuyerMutation,
  useUpdateBuyerResponseMutation,
} = investorPackageApi;
